const EMPTY_RESULT = { columns: [], data: [], executionTimeMs: null, executedAt: null, truncated: false };

export function columnName(column, index = 0) {
  if (typeof column === 'string') {
    return column;
  }
  return column?.name || column?.column_name || `col_${index}`;
}

export function messageIdOf(message) {
  return message?.messageId || message?.id;
}

export function previewToMessageChanges(preview) {
  const result = preview || {};
  return {
    columns: result.columns || [],
    data: result.data || [],
    executionTimeMs: result.executionTimeMs ?? null,
    executedAt: result.executedAt ?? null,
    truncated: result.truncated ?? false
  };
}

export function normalizeRow(row, columns) {
  if (!Array.isArray(row)) {
    return row;
  }
  return (columns || []).reduce(function(normalized, column, index) {
    normalized[columnName(column, index)] = row[index];
    return normalized;
  }, {});
}

export function parseRefreshedData(chart) {
  const raw = chart?.lastRefreshedData;
  if (!raw) {
    return { ...EMPTY_RESULT };
  }
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    const changes = previewToMessageChanges(parsed);
    return { ...changes, executedAt: changes.executedAt ?? chart?.lastRefreshedAt ?? null };
  } catch (_) {
    return { ...EMPTY_RESULT };
  }
}

export function rowCountOf(chart) {
  const { data } = parseRefreshedData(chart);
  return Array.isArray(data) ? data.length : null;
}
